import getConfig from "next/config";
import React, { useRef } from "react";
import { bool, func } from "prop-types";

import { LinkButton } from "./Button";
import Modal from "./Modal";
import Typography from "./Typography";

import { useConfigurationPathname } from "@hooks/useConfigurationPathname";

import { Trans, useTranslation } from "@lib/i18n";

const {
  publicRuntimeConfig: { ROOT_URL_PREFIX },
} = getConfig();

const RegistrationCostChangedModal = props => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();

  const configurationPathname = useConfigurationPathname();

  const modalFirstElement = useRef(null);

  return (
    <Modal
      ariaLabel={t("registrationCostChangedModal.heading")}
      disableBackdropClick
      disableEscapePress
      firstElement={modalFirstElement}
      isOpen={isOpen}
      onClose={onClose}
      preventGoBack
      withCloseIcon
    >
      <div className="flex flex-col items-center h-full gap-8 py-4 text-center">
        <h4 className="text-xl font-semibold">
          {t("registrationCostChangedModal.heading")}
        </h4>
        <Typography>
          <Trans i18nKey="registrationCostChangedModal.message" />
        </Typography>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <LinkButton
            href={`${ROOT_URL_PREFIX}${configurationPathname}`}
            ref={modalFirstElement}
          >
            {t("general.continue")}
          </LinkButton>
        </div>
      </div>
    </Modal>
  );
};

RegistrationCostChangedModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default RegistrationCostChangedModal;
